import { Avatar, CircularProgress, Stack, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import { useGetProjectMembersQuery } from "../../api/projects"
import { routesProfile } from "../../consts"
import modalEmitter from "../ModalComponent/modalEmitter"
import { ProjectTeamRoleChip } from "../ProjectPage/ProjectTeamRoleChip"
import { TeamSourceLabel } from "../ProjectPage/TeamSourceLabel"
import { StyledBadge } from "../ui-kit"

function getInitials(name: string | null | undefined): string {
  const value = (name ?? '').trim()
  if (!value) return '?'
  const parts = value.split(/\s+/).filter(Boolean)
  const first = parts[0]?.[0] ?? ''
  const second = (parts[1]?.[0] ?? parts[0]?.[1] ?? '') ?? ''
  return (first + second).toUpperCase()
}

export const ProjectMembersModalBody = ({ projectId }: { projectId: number }) => {
  const navigate = useNavigate()
  const { data: members = [], isLoading, isError } = useGetProjectMembersQuery({ projectId })

  const handleOpenProfile = (slug: string) => {
    const pathKey = slug.trim()
    if (!pathKey) {
      return
    }
    modalEmitter.emitCloseModal()
    navigate(`/${routesProfile.USERS.path}/${pathKey}`)
  }

  if (isLoading) {
    return (
      <Stack direction="row" gap={2} alignItems="center">
        <CircularProgress size={20} />
        <Typography>Загружаем участников…</Typography>
      </Stack>
    )
  }

  if (isError) {
    return <Typography color="error">Не удалось загрузить участников проекта.</Typography>
  }

  if (members.length === 0) {
    return <Typography>В команде пока нет участников.</Typography>
  }

  return (
    <Stack gap={2}>
      {members.map((member) => {
        const slug = (member.user.slug ?? '').trim()
        const title = (member.user.fullname ?? member.user.shortname ?? '').trim() || 'Пользователь'
        return (
          <Stack
            key={`${member.user.id ?? 'deleted'}-${member.team_role}-${member.is_author ? 'author' : 'member'}`}
            direction="row"
            gap={1.5}
            alignItems="center"
            sx={{ cursor: slug ? 'pointer' : 'default' }}
            onClick={slug ? () => handleOpenProfile(slug) : undefined}
          >
            <StyledBadge
              size={10}
              overlap="circular"
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              variant="dot"
              invisible={!member.user.is_online}
            >
              <Avatar src={member.user.avatar ?? undefined} alt={title}>
                {getInitials(title)}
              </Avatar>
            </StyledBadge>
            <Stack gap={0.25}>
              <ProjectTeamRoleChip
                teamRole={member.is_author ? 'author' : member.team_role}
                roleLabel={member.role_label}
                isAuthor={member.is_author}
              />
              {member.source_team && <TeamSourceLabel team={member.source_team} />}
              <Typography>{title}</Typography>
            </Stack>
          </Stack>
        )
      })}
    </Stack>
  )
}
